export default "__VITE_ASSET__CUr7eUKL__"